import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import VicinityContext from "../context/vicinityContext"
import { handlePlaceSelect } from "../utilities/places"

/**
 * Custom hook that provides a place selection handler with all necessary context
 * @returns {Object} Object containing handlePlaceSelect function and search state
 */
export const usePlaceSelect = () => {
    const navigate = useNavigate()
    const vicinityData = useContext(VicinityContext)
    const { setToastMessage, setToastOptions, setShowToast, toastOptions } =
        vicinityData

    const [searchInput, setSearchInput] = useState("")
    const [suggestions, setSuggestions] = useState([])

    const selectPlace = (placeId, showToast = true) =>
        handlePlaceSelect({
            placeId,
            vicinityData,
            setToastMessage,
            setToastOptions,
            setShowToast,
            toastOptions,
            setSearchInput,
            setSuggestions,
            navigate,
            showToast,
        })

    return {
        handlePlaceSelect: selectPlace,
        searchInput,
        setSearchInput,
        suggestions,
        setSuggestions,
    }
}
